<template>
  <div class="map-controls-container" :style="{height:!!containerHeight?containerHeight+'px':'600px'}">
    <div class="tmp-btns">
      <div>
        <span class="mr-10">地图显示比例：{{scale}}</span>
        <span>临时操作：</span>
        <button class="mr-10" @click="getMapSize()">获取地图Div尺寸</button>
        <button class="mr-10" @click="getShipImageSize()">获取地图图片尺寸</button>
        <button class="mr-10" @click="setImageBecoming()">正常显示</button>
        <button class="mr-10" @click="resetImageBecoming()">地图1比1</button>
        <button class="mr-10" @click="setScaleAdd()">地图放大</button>
        <button class="mr-10" @click="setScaleCut()">地图缩小</button>
      </div>
      <div class="mt-10">
        <button class="mr-10" @click="showDSCanvas()">给甲板设置区域</button>
        <button class="mr-10" @click="hideDSCanvas()">隐藏设置甲板</button>
        <button class="mr-10" @click="showOSSvg()">显示SVG</button>
        <button class="mr-10" @click="hideOSSvg()">隐藏SVG</button>
        <button class="mr-10" @click="showTempSvgFromCanvas()">SVG显示甲板设置Canvas</button>
        <button class="mr-10" @click="showOSSvgLineAnimation()">SVG路径动画开始</button>
        <button class="mr-10" @click="hideOSSvgLineAnimation()">SVG路径动画关闭</button>
      </div>
      <div class="mt-10">
        <button @click="showSetBaseStation($event)" class="mr-10">设置基站位置（包括到走廊路线）</button>
        <button class="mr-10" @click="hideSetBaseStation()">隐藏设置基站位置</button>
        <button class="mr-10" @click="showDrawArea()">画区域</button>
        <button class="mr-10" @click="hideDrawArea()">隐藏画区域</button>
      </div>
    </div>
    <div class="map-info">
      <span class="mr-15">缩放比例：{{scale}}</span>
      <span class="mr-15">X轴座标：{{Math.round(shipImage.left / scale)}}</span>
      <span class="mr-15">Y轴座标：{{Math.round(shipImage.top / scale)}}</span>
    </div>
    <div class="controls">
      <div class="item" title="放大" @click="setScaleAdd">
        <span class="zsf-icon zsf-icon-fangda"></span>
      </div>
      <div class="item" title="缩小" @click="setScaleCut">
        <span class="zsf-icon zsf-icon-suoxiao"></span>
      </div>
      <div class="item" title="移动">
        <span class="zsf-icon zsf-icon-mobile"></span>
      </div>
      <div class="item" title="重点区域">
        <span class="zsf-icon zsf-icon-quyu"></span>
      </div>
    </div>
    <div class="map-box" :style="{height:!!containerHeight?containerHeight+'px':'600px'}" id="map">
      <div class="set-deck-canvas" v-if="dsCanvasIsShow"
           :style="{width:containerInfo.width+'px',heigith:containerInfo.height+'px'}">
        <canvas id="set-deck-canvas"
                :style="{width:containerInfo.width+'px',heigith:containerInfo.height+'px'}"></canvas>
      </div>
      <div class="ship-img" :class="!movingFlag?'tran-all':''" id="moveDiv"
           :style="{ background:'white url('+shipImage.url+') no-repeat',width:shipImage.width+'px',height:shipImage.height+'px',transform:'scale('+scale+')',left:shipImage.left+'px',top:shipImage.top+'px'}">
        <div class="only-show-svg tran-all" v-if="osSvgIsShow"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
          <v-svg-polygon :svgPolygonPoints="svgPolygonPoints"></v-svg-polygon>
        </div>
        <div class="svg-line-animation-box" v-if="svgLineIsShow"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
          <v-svg-line ref="svgline" :scale="scale"></v-svg-line>
        </div>
        <div @click="setBaseStation" class="set-base-station-box"
             v-if="setBaseStationIsShow"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
              <span :style="{left:item.x+'px',top:item.y+'px',transform:'scale('+(1/scale)+')'}"
                    v-for="(item,index) in setBaseStationPoints"
                    :key="index"></span>
          <svg width="100%" height="100%" version="1.1">
            <line v-for="(item,index) in setBaseStationLigaturePoints"
                  :key="index" :x1="item.x1" :y1="item.y1"
                  :x2="item.x2" :y2="item.y2" style="stroke:red;stroke-width:2"></line>
          </svg>
        </div>
        <div class="draw-area-box" v-if="drawAreaIsShow"
             @click="drawArea"
             :style="{width:shipImage.width+'px',height:shipImage.height+'px'}">
                 <span :style="{left:item.x+'px',top:item.y+'px',transform:'scale('+(1/scale)+')'}"
                       v-for="(item,index) in drawAreaPoints"
                       :key="index"></span>
          <svg width="100%" height="100%" version="1.1">
            <polygon :points="drawAreaPolygon"
                     style="fill:rgba(255,0,0,0.1);stroke:#ff0000;stroke-width:2"></polygon>
          </svg>
        </div>
      </div>
    </div>
    <el-dialog :modal="false" title="设置基站"
               :visible.sync="setBaseStationDialogIsShow" width="600px">
      <span>设置基站的座标点和该基站到走廊的路线</span>
      <div slot="footer" class="dialog-footer">
        <el-button-group class="mr-10">
          <el-button size="mini" type="primary"
                     @click="setBaseStationPointEsc">重新设置
          </el-button>
          <el-button size="mini" type="primary"
                     @click="setBaseStationPointComeOn">继续添加座标点
          </el-button>
          <el-button size="mini" type="primary"
                     @click="setBaseStationPointSubmit">保存
          </el-button>
        </el-button-group>
      </div>
    </el-dialog>
    <el-dialog title="设置区域" :visible.sync="drawAreaDialogIsShow"
               :modal="false" width="600px">
      <div slot="footer" class="dialog-footer">
        <el-button-group class="mr-10">
          <el-button size="mini" type="primary" @click="drawAreaEsc">重新设置</el-button>
          <el-button size="mini" type="primary" @click="drawAreaComeOn">继续添加座标点</el-button>
          <el-button size="mini" type="primary" @click="drawAreaSubmit">保存</el-button>
        </el-button-group>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from '../common/js/tool.js';
  export default{
    data(){
      return {
        shipImage: {
          url: '',
          width: 0,
          height: 0,
          left: 0,
          top: 0,
        },
        distanceX: 0,
        distanceY: 0,
        containerInfo: {
          width: 0,
          height: 0
        },
        scale: 1,
        widthScale: 1,
        heightScale: 1,
        scaleStep: 0.05,
        movingFlag: false,
        dsCanvasIsShow: false,
        dsCanvasObj: {
          origin: '',
          originForSet: [0, 0, 0, 0],
          width2height: '',
          canvas: '',
          ctx: '',
          canDraw: true
        },
        osSvgIsShow: false,
        osCanvasObj: {
          canvas: '',
          ctx: ''
        },
        svgPolygonPoints: [
          {name: '甲板1', points: [{x: 10, y: 10}, {x: 250, y: 10}, {x: 210, y: 210}, {x: 10, y: 210}]},
          {name: '甲板2', points: [{x: 310, y: 310}, {x: 850, y: 410}, {x: 510, y: 510}, {x: 310, y: 510}]},
          {name: '甲板3', points: [{x: 810, y: 810}, {x: 1050, y: 810}, {x: 1010, y: 1010}, {x: 810, y: 1010}]}
        ],
        svgLineIsShow: false,
        setBaseStationIsShow: false,
        setBaseStationPoints: [],
        setBaseStationLigaturePoints: [],
        setBaseStationTempPoint: '',
        setBaseStationDialogIsShow: false,
        drawAreaIsShow: false,
        drawAreaPoints: [],
        drawAreaPolygon: '',
        drawAreaDialogIsShow: false
      }
    },

    props: ['containerHeight', 'ship_img', 'shipMapData'],

    computed: {},

    created(){
      //console.log(this.shipMapData);
    },

    mounted(){
      this.getShipImage();
      this.getMapSize();
      setTimeout(() => {
        this.setImageBecoming();
        this.monitorMove();
      }, 10)

      window.onresize = () => {
        this.getShipImage();
        this.getMapSize();
      };
    },

    methods: {
      test(){
        alert('test');
      },

      reset(){
        this.dsCanvasIsShow = false;
        this.osSvgIsShow = false;
        this.svgLineIsShow = false;
        this.setBaseStationIsShow = false;
        this.setBaseStationDialogIsShow = false;
        this.drawAreaIsShow = false;
        this.drawAreaDialogIsShow = false;
        let shipMapData = this.shipMapData;
        console.log(shipMapData);
        switch (shipMapData.type) {
          case 'setDeckArea':
            if (shipMapData.data.points.length > 4) {

            }
            break;
        }
      },

      emptyData(){
        this.setBaseStationPointEsc();
      },

      drawAreaEsc(){
        this.drawAreaDialogIsShow = false;
        this.drawAreaPolygon = '';
        this.drawAreaPoints = [];
      },

      drawAreaComeOn(){
        this.drawAreaDialogIsShow = false;
      },

      drawAreaSubmit(){
        this.drawAreaDialogIsShow = false;
        alert('保存，提交数据');
      },

      showDrawArea(){
        this.drawAreaIsShow = true;
      },

      hideDrawArea(){
        this.drawAreaIsShow = false;
      },

      drawArea(e){
        let tmp = [...this.drawAreaPoints];
        tmp.push({x: e.offsetX, y: e.offsetY});
        this.drawAreaPoints = tmp;
        console.log(this.drawAreaPoints);
        let array = [];
        for (let j = 0; j < tmp.length; j++) {
          array.push(tmp[j].x + ',' + tmp[j].y);
        }
        this.drawAreaPolygon = array.join(' ');
        if (this.drawAreaPoints.length > 2) {
          this.drawAreaDialogIsShow = true;
        }
      },

      showDrawArea(){
        this.drawAreaIsShow = true;
      },

      showSetBaseStation(e){
        this.setBaseStationIsShow = true;
        console.log(Math.round((e.offsetX - this.shipImage.left) / this.scale));
        console.log(Math.round((e.offsetY - this.shipImage.top) / this.scale));
      },

      hideSetBaseStation(e){
        this.setBaseStationIsShow = false;
      },

      setBaseStation(evt){
        console.log(evt.offsetX, evt.offsetY);
        let array = [...this.setBaseStationPoints];
        array.push({x: evt.offsetX, y: evt.offsetY});
        this.setBaseStationPoints = array;
        let tmp = [];
        for (let i = 0; i < array.length - 1; i++) {
          tmp.push({x1: array[i].x, y1: array[i].y, x2: array[i + 1].x, y2: array[i + 1].y});
        }
        this.setBaseStationLigaturePoints = tmp;
        console.log(this.setBaseStationPoints);
        console.log(this.setBaseStationLigaturePoints);
        if (this.setBaseStationPoints.length > 1) {
          this.setBaseStationDialogIsShow = true;
        }
      },

      setBaseStationPointEsc(){
        this.setBaseStationPoints = [];
        this.setBaseStationLigaturePoints = [];
        this.setBaseStationDialogIsShow = false;
      },

      setBaseStationPointComeOn(){
        this.setBaseStationDialogIsShow = false;
      },

      setBaseStationPointSubmit(){
        console.log(this.setBaseStationPoints);
        this.setBaseStationDialogIsShow = false;
        this.$emit('transmit', {data: this.setBaseStationPoints});
      },

      showOSSvgLineAnimation(){
        this.svgLineIsShow = true;
        setTimeout(() => {
          this.$refs.svgline.lineAnimationStart();
        }, 10);
      },

      hideOSSvgLineAnimation(){
        if (!this.svgLineIsShow) {
          return;
        }
        setTimeout(() => {
          this.$refs.svgline.lineAnimationStop();
          this.svgLineIsShow = false;
        }, 10);
      },

      showTempSvgFromCanvas(){
        let tmpDeck = tool.getCookie('deck1');
        console.log(tmpDeck);
        if (tmpDeck) {
          this.svgPolygonPoints = [
            {name: '甲板1', type: 'polygon', points: JSON.parse(tmpDeck)},
          ];
          this.showOSSvg();
        }
      },

      showOSSvg(){
        this.osSvgIsShow = true;
      },

      hideOSSvg(){
        this.osSvgIsShow = false;
      },

      hideDSCanvas(){
        this.dsCanvasIsShow = false;
      },

      showDSCanvas(){
        this.dsCanvasIsShow = true;
        let _this = this;
        setTimeout(() => {
          _this.dsCanvasObj.canDraw = true;
          _this.dsCanvasObj.origin = [0, 0];
          _this.dsCanvasObj.width2height = [0, 0];
          _this.dsCanvasObj.canvas = document.getElementById('set-deck-canvas');
          _this.dsCanvasObj.ctx = this.dsCanvasObj.canvas.getContext('2d');
          _this.dsCanvasObj.ctx.clearRect(0, 0, this.containerInfo.width, this.containerInfo.height);
          _this.dsCanvasObj.canvas.width = _this.containerInfo.width;
          _this.dsCanvasObj.canvas.height = _this.containerInfo.height;
          _this.dsCanvasObj.ctx.strokeStyle = 'red';
          _this.dsCanvasObj.ctx.fillStyle = 'green';
          _this.dsCanvasObj.canvas.onmousedown = function (e) {
            _this.setOneDeck().start(e);
            _this.dsCanvasObj.canvas.onmousemove = function (e) {
              _this.setOneDeck().move(e);
            };
            _this.dsCanvasObj.canvas.onmouseup = function (e) {
              _this.setOneDeck().end(e);
              _this.dsCanvasObj.canvas.onmousemove = null;
            }
          };
        }, 100)
      },

      setOneDeck(){
        return {
          start: (e) => {
            console.log('1-start');
            if (this.dsCanvasObj.canDraw === false) {
              return;
            }
            this.dsCanvasObj.origin = [e.offsetX, e.offsetY];
            this.dsCanvasObj.originForSet[0] = Math.round((e.offsetX - this.shipImage.left) / this.scale);
            this.dsCanvasObj.originForSet[1] = Math.round((e.offsetY - this.shipImage.top) / this.scale);
            console.log(this.dsCanvasObj.originForSet);
          },
          move: (e) => {
            console.log('2-move');
            if (this.dsCanvasObj.canDraw === false) {
              return;
            }
            if (this.dsCanvasObj.origin[0] !== 0 || this.dsCanvasObj.origin[1] !== 0) {
              this.dsCanvasObj.width2height = [e.offsetX - this.dsCanvasObj.origin[0], e.offsetY - this.dsCanvasObj.origin[1]];
              this.dsCanvasObj.ctx.clearRect(0, 0, this.containerInfo.width, this.containerInfo.height);
              this.dsCanvasObj.ctx.strokeRect(this.dsCanvasObj.origin[0], this.dsCanvasObj.origin[1], this.dsCanvasObj.width2height[0], this.dsCanvasObj.width2height[1]);
            }
          },
          end: (e) => {
            console.log('3-end');
            this.dsCanvasObj.originForSet[2] = Math.round((e.offsetX - this.shipImage.left) / this.scale);
            this.dsCanvasObj.originForSet[3] = Math.round((e.offsetY - this.shipImage.top) / this.scale);
            console.log(this.dsCanvasObj.originForSet);
            if (this.dsCanvasObj.canDraw === false) {
              return;
            }
            this.dsCanvasObj.ctx.globalAlpha = 0.2;
            this.dsCanvasObj.ctx.fillRect(this.dsCanvasObj.origin[0], this.dsCanvasObj.origin[1], this.dsCanvasObj.width2height[0], this.dsCanvasObj.width2height[1]);
            console.log(this.dsCanvasObj.origin);
            console.log(this.dsCanvasObj.origin[0], this.dsCanvasObj.origin[1], this.dsCanvasObj.width2height[0], this.dsCanvasObj.width2height[1]);
            let array = [];
            array.push({x: this.dsCanvasObj.originForSet[0], y: this.dsCanvasObj.originForSet[1]});
            array.push({
              x: this.dsCanvasObj.originForSet[2],
              y: this.dsCanvasObj.originForSet[1]
            });
            array.push({
              x: this.dsCanvasObj.originForSet[2],
              y: this.dsCanvasObj.originForSet[3]
            });
            array.push({
              x: this.dsCanvasObj.originForSet[0],
              y: this.dsCanvasObj.originForSet[3]
            });
            console.log(array);
            this.dsCanvasObj.origin = [0, 0];
            this.dsCanvasObj.canDraw = false;
            setTimeout(() => {
              this.$confirm("确定要保存甲板区域吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                tool.setCookie('deck1', JSON.stringify(array));
                tool.message('保存成功', 'success');
              });
            }, 200);
          }
        }
      },

      monitorMove(){
        let _this = this;
        document.ondblclick = null;
        let moveDiv = document.getElementById('moveDiv');
        let isDrag = false;
        let dx, dy, positionX, positionY;
        moveDiv.onmousedown = function (evt) {
          evt = evt || window.event;
          //console.log(evt);
          console.log(evt.offsetX, evt.offsetY);
          _this.movingFlag = true;
          isDrag = true;
          positionX = evt.clientX;
          positionY = evt.clientY;
          dx = moveDiv.offsetLeft;
          dy = moveDiv.offsetTop;
          document.onmousemove = function (evt) {
            evt = evt || window.event;
            _this.shipImage.left = dx + evt.clientX - positionX;
            _this.shipImage.top = dy + evt.clientY - positionY;
            return false;
          };
          document.onmouseup = function () {
            isDrag = false;
            _this.movingFlag = false;
            document.onmousemove = null;
            document.onmouseup = null;
          }
        }
      },

      setScaleAdd(){
        if (this.dsCanvasIsShow) {
          tool.message('设置甲板区域时，不能放大', 'error');
          return;
        }
        let scale = Math.round((this.scale + this.scaleStep) * 100) / 100;
        if (scale < 2) {
          this.scale = scale;
        } else {
          this.scale = 2;
          tool.message('不能再放大了！', 'warning');
        }
      },

      setScaleCut(){
        if (this.dsCanvasIsShow) {
          tool.message('设置甲板区域时，不能缩小', 'error');
          return;
        }
        let scale = Math.round((this.scale - this.scaleStep) * 100) / 100;
        if (scale > 0.1) {
          this.scale = scale;
        } else {
          this.scale = 0.1;
          tool.message('不能再缩小了！', 'warning');
        }
      },

      resetImageBecoming(){
        this.scale = 1;
        this.shipImage.left = 0;
        this.shipImage.top = 0;
        //console.log(this.shipImage);
      },

      //地图100%显示
      setImageBecoming(){
        let widthScale2 = this.containerInfo.width / this.shipImage.width;
        let heightScale2 = this.containerInfo.height / this.shipImage.height;
        this.widthScale = Math.floor(widthScale2 * 100) / 100;
        this.heightScale = Math.floor(heightScale2 * 100) / 100;
        //this.scale = this.widthScale > this.heightScale ? this.heightScale : this.widthScale;
        //this.scale = Math.floor((this.widthScale + 0.01) * 100) / 100;
        this.scale = Math.floor((this.heightScale + 0.01) * 100) / 100;
        this.shipImage.left = 0;
        this.shipImage.top = 0;
        //console.log(this.scale, widthScale2, heightScale2, this.widthScale, this.heightScale);
        //console.log(this.shipImage);
      },

      getShipImageSize(){
        alert(this.shipImage.width + '|' + this.shipImage.height);
      },

      getMapSize(){
        let container = document.getElementById('map');
        this.containerInfo.width = container.clientWidth;
        this.containerInfo.height = container.clientHeight;
        console.log(this.containerInfo.width + '|' + this.containerInfo.height);
      },

      upload(){
        tool.setCookie('shipImage', '../common/images/ship2.jpg');
        this.getShipImage();
      },

      getShipImage(){
        this.shipImage.width = this.ship_img.width;
        this.shipImage.height = this.ship_img.height;
        this.shipImage.url = this.ship_img.url ? require('../common/images/ship2.jpg') : '';
        //console.log(this.shipImage);
      }
    },

    components: {}
  }
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
  @import "../common/less/ship-map.less";
</style>
